<div class="container-fluid pt-3">
  <div class="jumbotron bg-transparent pb-0">
    <h1 class="display-5">Event Activity Dashboard</h1>
    <hr class="my-4">
  </div>
</div>
<app-power-bi-input [reportInput]="powerBIConfig"></app-power-bi-input>
